import { ApplicationConfig } from '@angular/core';

import { provideAgileApp } from '@app-config';
import { routes } from './app.routes';
import { REPORTING_SERVICE_CODE } from './common/reporting.constants';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAgileApp({ routes, rootModule: { serviceCode: REPORTING_SERVICE_CODE, homePath: 'reports' } })
    ]
};
